// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602191234/js/" + chunkId + "." + {"44":"9a65821d","225":"08dd38a2","481":"f5db5ae6","486":"f00ce680","770":"038f9639"}[chunkId] + ".0.657822742347667.chunk.js";
};